import React, { createContext, useCallback, useContext, useRef } from 'react';
import { ConfigProvider } from 'antd';

import { useXoeContainerSize } from '../../hooks/xoe/useXoeContainerSize';
import type { XoeContainerSize, XoeSurfaceProps } from '../../types/xoe/XoeUiTypes';

import './xoe.css';

const XoeSizeContext = createContext<XoeContainerSize>('regular');

export const useXoeSize = (): XoeContainerSize => useContext(XoeSizeContext);

const XoeSurface: React.FC<XoeSurfaceProps> = ({ children, className, style, 'data-testid': testId }) => {
	const rootRef = useRef<HTMLDivElement>(null);
	const size = useXoeContainerSize(rootRef);

	// Only trigger-anchored popups mount in the root; Modal/Drawer ask with no trigger (or body) and stay page-level.
	const getPopupContainer = useCallback((trigger?: HTMLElement) => {
		const root = rootRef.current;
		return root && trigger && root.contains(trigger) ? root : document.body;
	}, []);

	return (
		<div
			ref={rootRef}
			className={className ? `mg-xoe ${className}` : 'mg-xoe'}
			style={style}
			data-size={size}
			data-testid={testId}
		>
			<XoeSizeContext.Provider value={size}>
				<ConfigProvider getPopupContainer={getPopupContainer}>{children}</ConfigProvider>
			</XoeSizeContext.Provider>
		</div>
	);
};

export default XoeSurface;
